import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "parentDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      parentData: [],
      studentList: [],
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      saveIndexes: []
    };
  },

  methods: {
    getDetail() {
      axios.get(`parent/detail/${this.$route.params.id}`)
      .then(res => {
        if (res.data) {
          this.parentData = res.data[0];
          this.getStudentList();
        }
        this.isLoading = false;
      })
      .catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log("Parent Detail API Error", error);
      })
    },

    getStudentList() {
      this.isLoading = true;
      axios
        .get(`student/list/${this.$route.params.id}`, {
          params: {
            campus_id: this.$store.state.user.campus_id,
          },
        })
        .then((res) => {
          if (res.data) {
            this.studentList = res.data.data;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
          console.log("Student List API Error", error);
        });
    },

    showStudentCreate(parentId) {
      this.$router.push({
        name: "studentCreate",
        params: {
          parentId: parentId
        }
      });
    },

    showDetail(classStudentId, leavedStatus = "active") {
      this.$router.push({
        name: "studentProfile",
        params: {
          leavedStatus: leavedStatus,
          id: classStudentId,
        }
      });
    },

    toggleRow(gradeResult, rowIndex) {
      const indexPos = this.saveIndexes.indexOf(rowIndex);

      if (this.saveIndexes.includes(rowIndex)) {
        this.removeRow(rowIndex);
        this.saveIndexes.splice(indexPos, 1);
      } else {
        this.addRow(gradeResult, rowIndex);
        this.saveIndexes.push(rowIndex);
      }
    },

    removeRow(rowIndex) {
      const addedRows = document.getElementsByClassName(`row-add-${rowIndex}`);
      Array.from(addedRows).forEach(el => el.remove());

      const mainRow = document.getElementsByClassName('row-' + rowIndex)[0];
      if (mainRow) {
        const rowTds = mainRow.children;
        for (let i = 0; i < 8; i++) {
          if (i === 5 || i === 6) continue;
          rowTds[i].removeAttribute('rowspan');
          rowTds[i].removeAttribute('class');
        }
      }
    },

    addRow(gradeResult, rowIndex) {
      this.tmpClasses = [];
      this.tmpClasses = gradeResult.slice(0);
      this.tmpClasses.splice(0,1);

      var table = document.getElementById('active-table');
      var originalRowCount = table.rows.length;
      var afterRow = document.getElementsByClassName('row-' + (rowIndex + 1));
      var checkedRow = document.getElementsByClassName('row-' + rowIndex);
      var rowTd = checkedRow[0].children;
      for(let i = 0; i < 8; i++) {
        if (i == 5 || i == 6) continue;

        rowTd[i].setAttribute('rowspan', this.tmpClasses.length + 1);
        rowTd[i].className = 'addSpan';
      }
      var fragment = document.createDocumentFragment();
      this.tmpClasses.forEach( e => {
        var newRow = document.createElement("tr");
        newRow.classList.add('row-add', `row-add-${rowIndex}`);
        var rowTpl = `
        <td data-label="Class Name">
            ${e.grade}
        </td>
        <td data-label="Exam Result" class="exam-result">
              ${e.status}
        </td>
        `
        newRow.innerHTML = rowTpl;

        fragment.appendChild(newRow);
      })
      if (rowIndex < originalRowCount - 1) {
          table.tBodies[0].insertBefore(fragment, afterRow[0]);
      } else {
          table.tBodies[0].appendChild(fragment);
      }
    }
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  },
};
